
import { Component, Vue } from 'vue-property-decorator';
import { UserModule } from '~/store/modules/user';

@Component({})
export default class DeleteAccount extends Vue {
    isDialogOpen = false;

    async deleteAccount(): Promise<void> {
        await UserModule.deleteAccount();
        this.isDialogOpen = false;
    }

    get userMail(): string {
        return UserModule.userMail;
    }
}
